import MUIModal from './Modal.MUI.view';

export default MUIModal;
